// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2vebE","buttons":"SendReceipts_buttons__UL95j","email":"SendReceipts_email__3pxql","bookApptTitle":"SendReceipts_bookApptTitle__39Owv"};